const numSort = (a, b) => a - b;
export default numSort;
